import React from "react";
import { Text, Flex, Authenticator, Tabs } from "@aws-amplify/ui-react";
import { PageIndex, PageTitle } from "../util/SEO";
import SearchableQuizCollection from "../features/quiz/components/Discovery/SearchableQuizCollection";
import DiscoveryQuizCard from "../features/quiz/components/Discovery/DiscoveryQuizCard";
import { useNavigate } from "react-router-dom";
import fetchPaginatedListPublicQuizzes from "../features/quiz/utils/fetchPaginatedListPublicQuizzes";
import fetchPaginatedSearchPublicQuizzes from "../features/quiz/utils/fetchPaginatedSearchPublicQuizzes";
import LessonCollection from "../features/quiz/components/Discovery/LessonCollection";
import { querySearchPublicLessons } from "../features/lesson/services/querySearchPublicLessons";
import WinPremiumButton from "../features/referrals/components/WinPremiumButton";

export default function Discovery() {
  PageTitle("Discover | Gibbly");
  PageIndex("noindex");

  const navigate = useNavigate();

  return (
    <>
      <Authenticator>
        <Flex direction={"column"} padding={"medium"} paddingTop={"large"}>
          <Flex justifyContent={"space-between"}>
            <Text id="pageTitle">Discover Resources</Text>

            <Flex alignItems={"flex-end"}>
              <WinPremiumButton />
            </Flex>
          </Flex>

          <Tabs.Container defaultValue="quizzes">
            <Tabs.List>
              <Tabs.Item value="quizzes">Quizzes</Tabs.Item>
              <Tabs.Item value="lessons">Lessons</Tabs.Item>
            </Tabs.List>
            <Tabs.Panel value={"quizzes"} fontSize={"small"}>
              <SearchableQuizCollection
                collectionType="discovery-dashboard"
                queryKey="Discovery Quiz Ids"
                CardComponent={DiscoveryQuizCard}
                cardFunctionalProps={{
                  width: {},
                  hasButtons: true,
                  onClick: (quizId) => navigate(`/quiz/${quizId}`),
                }}
                fetchPaginatedList={(pageParam) =>
                  fetchPaginatedListPublicQuizzes(pageParam)
                }
                fetchPaginatedSearch={(search, pageParam) =>
                  fetchPaginatedSearchPublicQuizzes(search, pageParam)
                }
                templateColumns={{
                  base: "100%",
                  small: "minmax(0,1fr) minmax(0,1fr) ",
                  medium: "minmax(0,1fr) minmax(0,1fr) minmax(0,1fr)",
                  large:
                    "minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr)",
                  xl: "minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr)",
                }}
              />
            </Tabs.Panel>
            <Tabs.Panel value={"lessons"} fontSize={"small"}>
              <LessonCollection
                collectionType="discovery-dashboard"
                listFunction={async () => {
                  const lessons = await querySearchPublicLessons("");
                  const sortedLessons = lessons.sort((a, b) => {
                    if (a.createdAt > b.createdAt) return -1;
                    if (a.createdAt < b.createdAt) return 1;
                    return 0;
                  });
                  return sortedLessons;
                }}
                searchFunction={async (search) => {
                  const lessons = await querySearchPublicLessons(search);
                  const sortedLessons = lessons.sort((a, b) => {
                    if (a.createdAt > b.createdAt) return -1;
                    if (a.createdAt < b.createdAt) return 1;
                    return 0;
                  });
                  return sortedLessons;
                }}
              />
            </Tabs.Panel>
          </Tabs.Container>
        </Flex>
      </Authenticator>
    </>
  );
}
